module.exports = "<svg viewBox=\"0 0 32.3 26.1\"><path d=\"M16.1 18L0 0v26.1h32.3V0z\" class=\"st0\"></path><path d=\"M5.8 0h20.7L16.1 11z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/mail.svg
// module id = 303
// module chunks = 1